var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiftHealth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_10059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2814 23.9653L34.6978 23.9653C35.2641 23.9653 35.7231 23.5063 35.7231 22.9399L35.7231 12.6177C35.7231 12.0513 35.2641 11.5923 34.6978 11.5923L32.2814 11.5923L32.2814 23.9653Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2306 25.3325L30.2306 10.2251C30.2306 9.65873 29.7716 9.19971 29.2052 9.19971L1.74849 9.19971C1.18213 9.19971 0.723103 9.65873 0.723103 10.2251L0.723102 25.3325C0.723102 25.8989 1.18212 26.3579 1.74849 26.3579L29.2052 26.3579C29.7716 26.3579 30.2306 25.8989 30.2306 25.3325ZM17.5558 21.8932L8.84719 18.1393C8.16733 17.8464 8.37348 16.8325 9.11368 16.8282L14.4412 16.7964L14.4155 14.6076C14.4099 14.1154 14.9101 13.7787 15.3638 13.9694L23.6668 17.4562C24.3549 17.7452 24.1482 18.77 23.4021 18.77L18.5572 18.77L18.5099 21.2782C18.5008 21.7639 18.002 22.0854 17.5558 21.8932Z",
    fill: "#2776CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_10059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(35.7231 0.312988) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftHealth);
export default __webpack_public_path__ + "static/media/LiftHealth.322fd5b90b703561fb193a495984457e.svg";
export { ForwardRef as ReactComponent };